export const copyToClipboard = (s: string) => {
	navigator.clipboard.writeText(s).catch(e => e);
};
